export function startVersionPolling(interval = 30000) {
  if (process.env.NODE_ENV !== 'production') {
    console.log('🛑 Skipping version polling in development mode.');
    return;
  }

  let currentHash = window.BUILD_HASH;
  console.log('✅ Initial BUILD_HASH:', currentHash);

  const waitUntilHashAvailable = () => {
    if (!window.BUILD_HASH) {
      return setTimeout(waitUntilHashAvailable, 500);
    }

    setInterval(async () => {
      try {
        const res = await fetch(`/version.js?t=${Date.now()}`, { cache: 'no-store' });
        const text = await res.text();

        const match = text.match(/window\.BUILD_HASH\s*=\s*['"]([^'"]+)['"]/);
        const newHash = match?.[1];

        if (newHash && newHash !== currentHash) {
          console.log('🚨 New version detected. Reloading...');
          window.location.reload();
        } else {
          console.log('✅ No version change detected.');
        }
      } catch (err) {
        console.error('❌ Version polling failed:', err);
      }
    }, interval);
  };

  waitUntilHashAvailable();
}
